import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LogIn } from '../_models/log-in';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(private http: HttpClient) { }

  public static readonly FORGOT_PASSWORD_CONTROLLER_URL=environment.apiURL+"forgotPassword/"

  public forgotPassword(logInDataForm: LogIn):Observable<HttpResponse<LogIn>>{
    {
      return this.http.post<LogIn>(ForgotPasswordService.FORGOT_PASSWORD_CONTROLLER_URL , logInDataForm ,{ observe: 'response' })
      .pipe(map(response => {
        return response;
      }));
  }
  }
}
